module.exports = __webpack_public_path__ + "static/media/Ubuntu-Regular.2505bfbd.ttf";